import React, { useState } from 'react';
import { Drawer, IconButton, Box, Typography } from '@mui/material';
import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper'
import MenuIcon from '@mui/icons-material/Menu';
import "./atomicDrawer.scss";

export default function AtomicDrawer({ children }) {
    const [open, setOpen] = useState(false);

    const toggleDrawer = (openState) => () => {
        setOpen(openState);
    };

    return (
        <div>
            {/* Burger icon */}
            <IconButton onClick={toggleDrawer(true)} edge="start" color="inherit" aria-label="menu">
                <MenuIcon style={{ color: 'white' }} />
            </IconButton>

            {/* Drawer from top */}
            <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
                <div style={{ minHeight: '300px' }}>

                    {children}

                </div>
            </Drawer>
        </div>
    );
}